// Reminder: https://github.com/nikolaynesov/vue-body-class/issues/9.
// I simplified how it loops over the possible meta body class name stuff, but I barely use it so admit that I have done only manual testing, and little at that.

class VueBodyClassController {
  init(router) {
    this.bodyClass = document.body.className;
    this.router = router;
  }

  set router(router) {
    router.beforeEach((to, from, next) => {
      var additionalClassName = "";

      if (to.matched.length > 0) {
        additionalClassName = to.matched.reduce((a, v) => {
          a = this.updateClassFromRoute(a, v);
          return a;
        }, '')
      }

      document.body.className = (this.bodyClass + additionalClassName).trim();

      next();
    });
  }

  parseMatched(matchedArray) {
    var matched = [];

    for (let index in matchedArray) {
      let prev = matched.join("/");

      matched.push(
        matchedArray[index].path
          .replace(/^\/|\/$/g, "")
          .replace(prev, "")
          .replace(/^\/|\/$/g, "")
      );
    }

    return matched;
  }

  findMatchInRoutesByPath(routes, matchedItem) {
    return routes.find(o => {
      return o.path.replace(/^\/|\/$/g, "") == matchedItem;
    });
  }

  getClassForRoute(route) {
    return route.meta ? route.meta.bodyClass : null;
  }

  updateClassFromRoute(className, route) {
    var routeClass = this.getClassForRoute(route);

    if (routeClass) {
      let routeBodyClass = routeClass.replace(/^!/, "");

      if (routeClass.indexOf("!") === 0) {
        className = " " + routeBodyClass;
      } else {
        className += " " + routeBodyClass;
      }
    }

    return className;
  }
}

let VueBodyClass = new VueBodyClassController();

VueBodyClass.install = (Vue, router) => {
  VueBodyClass.init(router);
};

export default VueBodyClass;
